export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  image: string;
  category: string;
  categorySlug: string;
  author: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: "article-1",
    title: "流浪地球3票房突破50亿，国产科幻电影再创辉煌",
    excerpt: "《流浪地球3》上映以来票房一路高歌，首周即突破20亿大关，如今累计票房已超50亿，成为中国科幻电影的新里程碑。",
    content: `<p>在这个暑期档，《流浪地球3》无疑是最耀眼的那颗星。自上映以来，该片凭借其震撼的视觉效果、扣人心弦的剧情以及深刻的人文主题，赢得了观众的广泛好评。</p>
    <p>作为"流浪地球"系列的第三部作品，本片在延续前作宏大叙事的同时，进一步深化了对人类命运共同体的思考。导演郭帆在接受采访时表示："我们希望这个系列不仅是一场视觉盛宴，更能引发观众对人类未来的思考。"</p>
    <p>影片中，地球面临着前所未有的危机，人类再次启动行星发动机，开启了一段充满未知的旅程。吴京、刘德华等演员的出色表演也获得了观众的一致认可。影评人认为，这部电影标志着中国科幻电影进入了一个全新的阶段。</p>
    <p>票房分析师指出，《流浪地球3》的成功不仅体现在数字上，更重要的是它证明了中国科幻电影的市场潜力和制作能力。预计该片最终票房有望冲击60亿大关。</p>`,
    date: "2026-07-28",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%2C%20futuristic%20city%20with%20massive%20engines%20glowing%20warm%20orange%2C%20crowd%20of%20people%20watching%20in%20awe%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20warm%20atmospheric%20tones%2C%20sci-fi%20aesthetic%2C%20cinematic%20quality&width=1200&height=630&seq=article-wandering-3&orientation=landscape",
    category: "电影资讯",
    categorySlug: "news",
    author: "电影观察员",
    tags: ["流浪地球3", "票房", "科幻电影", "郭帆"],
  },
  {
    id: "article-2",
    title: "2025年最值得期待的十大华语电影盘点",
    excerpt: "新的一年，华语电影市场持续火热。从科幻大片到温情喜剧，从动画巨制到悬疑推理，我们为你盘点2025年最不容错过的十部华语电影。",
    content: `<p>2025年的华语电影市场可谓群星闪耀，各类题材精彩纷呈。我们精心挑选了十部最值得期待的影片，让你提前做好观影计划。</p>
    <p><strong>1. 《封神第二部》</strong> — 继第一部取得巨大成功后，第二部将展现更加宏大的神话战争场面。</p>
    <p><strong>2. 《哪吒之魔童闹海》</strong> — 国产动画的顶级制作，哪吒与敖丙的故事继续上演。</p>
    <p><strong>3. 《红海行动2》</strong> — 林超贤导演再次打造军事动作大片，蛟龙突击队再度出征。</p>
    <p><strong>4. 《唐人街探案4》</strong> — 唐仁和秦风的侦探之旅来到伦敦，喜剧与悬疑的完美结合。</p>
    <p>除了这些续集大片，还有多部原创作品备受关注。业内人士认为，2025年将是华语电影全面爆发的一年，无论是制作水准还是内容创新都将达到新高度。</p>`,
    date: "2025-01-15",
    image: "https://readdy.ai/api/search-image?query=Cinema%20marquee%20with%20multiple%20movie%20posters%20displayed%2C%20warm%20golden%20theater%20lights%2C%20elegant%20red%20carpet%20entrance%2C%20excited%20crowd%2C%20premium%20cinema%20atmosphere%2C%20warm%20ambient%20lighting%2C%20professional%20photography&width=1200&height=630&seq=article-2025-movies&orientation=landscape",
    category: "电影盘点",
    categorySlug: "ranking",
    author: "影迷小王",
    tags: ["2025电影", "华语电影", "电影推荐", "观影指南"],
  },
  {
    id: "article-3",
    title: "深度解析：《封神第二部》神话世界观与人物关系",
    excerpt: "《封神第二部》构建了一个庞大而精细的神话世界，本文将深入解析影片中的世界观设定、阵营划分与核心人物关系。",
    content: `<p>《封神第二部》在继承中国古典神话的基础上，构建了一个令人叹为观止的奇幻世界。影片中的世界观设定极其丰富，包含了人界、仙界、妖界三大阵营。</p>
    <p>在人界方面，殷商与西岐的对立构成了故事的主线。殷商阵营由纣王统领，拥有强大的军队和部分仙人的支持；而西岐则在姜子牙的辅佐下，汇聚了众多正义之士。</p>
    <p>仙界层面，元始天尊座下的十二金仙各具特色，他们的立场和抉择直接影响着人间战局的走向。影片巧妙地展现了神仙并非全知全能，他们也有自己的考量和局限。</p>
    <p>人物关系方面，姬发与殷郊的兄弟情谊、姜子牙与申公豹的师门恩怨、妲己与纣王之间的纠葛，每一条线索都编织得丝丝入扣。导演乌尔善表示，第二部将进一步深化这些人物关系。</p>`,
    date: "2025-06-20",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20ornate%20decorations%2C%20warm%20golden%20candlelight%2C%20mythological%20murals%20on%20walls%2C%20traditional%20Chinese%20aesthetic%2C%20mystical%20atmosphere%2C%20rich%20warm%20amber%20tones%2C%20cinematic%20lighting&width=1200&height=630&seq=article-fengshen-analysis&orientation=landscape",
    category: "深度解析",
    categorySlug: "analysis",
    author: "电影观察员",
    tags: ["封神第二部", "神话", "世界观", "深度解析"],
  },
  {
    id: "article-4",
    title: "国产动画的崛起之路：从《大圣归来》到《深海》",
    excerpt: "从2015年的《大圣归来》到如今的《深海》，国产动画走过了一条不平凡的崛起之路。本文将回顾这段发展历程。",
    content: `<p>十年前，提到国产动画，很多人的第一反应还是"低幼"和"粗糙"。然而今天，国产动画已经成为中国电影市场的重要力量。</p>
    <p>2015年，《西游记之大圣归来》以9.56亿的票房打破国产动画票房纪录，让人们第一次看到了国产动画的潜力。此后，《大鱼海棠》《白蛇：缘起》《哪吒之魔童降世》等一系列优秀作品相继问世。</p>
    <p>2024年，《深海》以其独特的粒子水墨风格惊艳了观众。导演田晓鹏耗时七年打造这部作品，将中国传统水墨画与现代3D技术完美融合，创造了前所未有的视觉体验。</p>
    <p>业内专家表示，国产动画的成功得益于三个关键因素：一是技术的不断进步，二是对传统文化的深入挖掘，三是创作者对品质的执着追求。未来，国产动画有望走向更广阔的国际市场。</p>`,
    date: "2024-11-08",
    image: "https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20workspace%2C%20artists%20working%20on%20digital%20tablets%2C%20colorful%20concept%20art%20on%20walls%2C%20warm%20creative%20atmosphere%2C%20modern%20studio%20with%20traditional%20Chinese%20elements%2C%20golden%20warm%20lighting%2C%20professional%20setting&width=1200&height=630&seq=article-animation-rise&orientation=landscape",
    category: "行业观察",
    categorySlug: "industry",
    author: "动画爱好者",
    tags: ["国产动画", "深海", "大圣归来", "动画产业"],
  },
  {
    id: "article-5",
    title: "朱一龙演技再获认可：《消失的她》中的精彩表现",
    excerpt: "在悬疑片《消失的她》中，朱一龙展现出了令人惊叹的演技层次感，将一个陷入困境的丈夫形象刻画得入木三分。",
    content: `<p>《消失的她》自上映以来，朱一龙的表演一直是最热门的话题之一。在这部悬疑片中，他饰演的何非是一个复杂的角色——既有表面的脆弱和无助，又隐藏着深层的心机和算计。</p>
    <p>从《人生大事》中的莫三妹到《消失的她》中的何非，朱一龙用两个截然不同的角色证明了自己的演技实力。影评人指出，朱一龙在《消失的她》中的表演极具层次感，通过细微的表情变化和肢体语言，将角色的内心矛盾完美呈现在银幕上。</p>
    <p>在多个关键场景中，朱一龙的表演令人印象深刻。特别是在警局报案的那场戏，他通过眼神和微表情传达出复杂的情感，让观众既同情又怀疑。这种"演技的模糊地带"正是悬疑片最需要的表演质感。</p>
    <p>导演崔睿评价道："朱一龙是一个极其投入的演员，他会深入研究角色的每一个细节，甚至为角色设计了一些剧本上没有的小动作，这些细节让角色更加立体。"</p>`,
    date: "2024-09-22",
    image: "https://readdy.ai/api/search-image?query=Film%20set%20lighting%20setup%20with%20warm%20golden%20spotlight%20on%20an%20empty%20stage%2C%20movie%20camera%20in%20silhouette%2C%20cinematic%20atmosphere%2C%20dramatic%20warm%20lighting%2C%20professional%20film%20production%20environment%2C%20elegant%20composition&width=1200&height=630&seq=article-actor-performance&orientation=landscape",
    category: "演员聚焦",
    categorySlug: "actor",
    author: "影迷小王",
    tags: ["朱一龙", "消失的她", "演技", "演员"],
  },
  {
    id: "article-6",
    title: "电影特效技术揭秘：国产科幻大片背后的视觉魔法",
    excerpt: "从《流浪地球》到《独行月球》，国产科幻电影的视觉效果突飞猛进。本文将揭秘这些惊艳画面背后的技术力量。",
    content: `<p>当你被《流浪地球3》中壮观的行星发动机所震撼，或是被《独行月球》中的月球基地所惊艳时，你是否好奇这些画面是如何制作出来的？</p>
    <p>国产科幻电影的视觉效果进步得益于多个方面。首先是本土特效公司的崛起，MOREVFX等公司在参与国际项目的过程中积累了丰富经验，如今已经能够独立完成高难度的特效制作。</p>
    <p>其次是技术创新。在《深海》中，团队开发了全新的粒子水墨渲染技术，将中国传统水墨画与现代CG技术相结合，创造出了独一无二的视觉效果。这项技术研发就花费了近三年时间。</p>
    <p>再者是人才储备的培养。越来越多国内高校开设了视觉特效相关专业，为行业输送了大量优秀人才。同时，许多在海外学习的特效人才也选择回国发展，带回了先进的制作理念。</p>
    <p>业内人士表示，中国电影特效行业正处于快速发展期，与国际顶尖水平的差距正在迅速缩小。</p>`,
    date: "2024-08-05",
    image: "https://readdy.ai/api/search-image?query=Modern%20visual%20effects%20studio%20with%20large%20monitors%20displaying%203D%20rendering%2C%20motion%20capture%20equipment%2C%20creative%20tech%20environment%2C%20warm%20ambient%20lighting%2C%20professional%20workspace%2C%20cinematic%20color%20grading&width=1200&height=630&seq=article-vfx-tech&orientation=landscape",
    category: "技术揭秘",
    categorySlug: "tech",
    author: "电影观察员",
    tags: ["特效", "科幻电影", "视觉技术", "CG制作"],
  },
];

export const latestArticles = [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());